import PropTypes from 'prop-types';

export const dateRangeOptions = [
    {
        name: 'Overdue',
        value: 'overdue',
    },
    {
        name: 'This Week',
        value: 'this_week',
    },
    {
        name: 'Today',
        value: 'today',
    },
    {
        name: 'Next Week',
        value: 'next_week',
    },
    {
        name: 'In 2 Weeks',
        value: 'week_after',
    },
    {
        name: 'Within a Year',
        value: 'all_pending_activities',
    },
    {
        name: 'Custom',
        value: 'custom',
    },
];

export const allNonRequiredFilters = [
    { id: 'activity_filter', option: 'Activity Filter' },
    { id: 'branch', option: 'Branch' },
    { id: 'therapeutic_category', option: 'Therapeutic Category' },
    { id: 'predictive_model_filter', option: 'Predictive Model Filter' },
];

export const cellPropsType = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            patientId: PropTypes.string,
            activityId: PropTypes.string,
            dateDue: PropTypes.string,
            type: PropTypes.string,
        }),
    }),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const FILTER_TYPE = {
    WORK_QUEUE: 'workQueue',
    ASSIGNMENT_MANAGER: 'assignmentManager',
};
